module.exports = __webpack_public_path__ + "static/media/ReactiveBurger_19.f78e5b3f.webp";